<template>
  <div :class="`main-header ${headerClass}`">
    <div class="container">
      <Header />
    </div>
  </div>
  <div :class="`relative ${headerClass}`">
    <div class="relative banner-background n3-banner-min-height city-bg">
      <div class="card-top-overlay"></div>
      <div class="card-bottom-overlay light"></div>
      <div :class="`flex items-end n3-content-min-height`">
        <div class="container z-10 relative">
          <div class="absolute bottom-[-10pc] w-full">
            <div class="main-subtitle">Ongoing shows in</div>
            <div class="main-title">{{ $route.params.city }}</div>
            <div class="grid grid-cols-5 grid-flow-col gap-[6rem]">
              <div class="col-span-3">
                <div class="text-subtitle">
                  <div class="mt-1" v-if="shows.length">
                    {{ shows.length }} show available in
                    {{ $route.params.city }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="relative">
    <div class="before-transparent"></div>
  </div>
  <div class="container">
    <div class="grid grid-cols-1 lg:grid-cols-4 gap-4">
      <div class="col-3 mb-5" v-for="(show, index) in shows" :key="index">
        <n-3-show-card
          :item="{
            title: show.movie.title,
            subtitle: show.movie.subtitle,
            subtitle2: dateTimeFormat(show.start.toDate(), 'ddd Do MMM YYYY'),
            image: show.movie.posterUrlSquare,
            url: `/event/${show.movie?.slug}`,
          }"
        />
      </div>
    </div>
  </div>
  <Footer :class="headerClass" />
</template>
<script>
import Header from "@/components/Header.vue";
import { computed, onMounted, reactive, toRefs } from "@vue/runtime-core";
import { useStore } from "vuex";
import { dateTimeFormat, scrollToTop } from "@/utils/helper";
import Footer from "@/components/Footer.vue";
import { useRoute } from "vue-router";
import N3ShowCard from "@/components/home/N3ShowCard.vue";
import { useMeta } from "vue-meta";

export default {
  components: { Header, Footer, N3ShowCard },
  setup() {
    const store = useStore();
    const route = useRoute();
    const state = reactive({
      shows: computed(() => store.state.show.shows),
      showHeader: computed(() => store.state.event.showHeader),
      description: computed(() => {
        let des = [
          `${state.shows.length} show are screening in ${route.params.city}`,
          `Check out latest show times at N3 ${route.params.city} and other nearby theatres in your city. Book movie/event tickets at cinemas near you in ${route.params.city}.`,
        ];
        state.shows.map((a) => {
          des.push(a.movie.description);
        });

        return des.join(", ");
      }),
      keywords: computed(() => {
        let keys = [
          `latest shows in ${route.params.city}`,
          `latest movies in ${route.params.city}`,
          `theaters in ${route.params.city}`,
          `N3 Booking in ${route.params.city}`,
        ];
        state.shows.map((a) => {
          keys.push(`${a.movie.title} in ${route.params.city}`);
        });
        return keys.join(", ");
      }),
      headerClass: computed(() => {
        return state.showHeader ? "" : "hidden sm:block";
      }),
    });

    useMeta(
      computed(() => ({
        title: "Show time in " + route.params.city,
        description: state.description,
        meta: [
          {
            name: "keywords",
            content: state.keywords,
          },
        ],
      }))
    );

    onMounted(async () => {
      store.dispatch("show/fetchShowByCity", route.params.city);
      scrollToTop();
    });

    return {
      ...toRefs(state),
      dateTimeFormat,
    };
  },
};
</script>
<style lang="scss">
.city-bg {
  background-image: url(@/assets/img/banner/frankfurt.jpeg);
}
</style>
